module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/board/bg-926.jpg"+" 926w",
        images: [{path: __webpack_public_path__ + "assets/images/board/bg-926.jpg",width: 926,height: 560}],
        src: __webpack_public_path__ + "assets/images/board/bg-926.jpg",
        toString: function(){return __webpack_public_path__ + "assets/images/board/bg-926.jpg"},
        
        width: 926,
        height: 560
      }